import {
  GET_ALL_CATEGORIES,
  SET_CATEGORY,
  CATEGORY_HELPERS,
  SET_CATEGORIES
} from 'src/store/mutation-types'

export default {
  [GET_ALL_CATEGORIES] (state, categories) {
    state.categories = categories
  },
  [SET_CATEGORY] (state, category) {
    state.category = category
  },
  [CATEGORY_HELPERS] (state, categoryHelpers) {
    state.categoryHelpers = categoryHelpers
  },
  [SET_CATEGORIES] (state, categories) {
    state.categories = categories
  }
}



// WEBPACK FOOTER //
// ./src/components/category/store/mutations.js